import { toast } from "sonner";

type CopyOptions = {
	successMessage: string;
	errorMessage: string;
};

export async function copyToClipboard(
	value: string,
	options: CopyOptions,
): Promise<boolean> {
	try {
		await navigator.clipboard.writeText(value);
		toast.success(options.successMessage);
		return true;
	} catch {
		toast.error(options.errorMessage);
		return false;
	}
}
